import { render, staticRenderFns } from "./ConsultarConcursos.vue?vue&type=template&id=8ff7017e&scoped=true&"
import script from "./ConsultarConcursos.vue?vue&type=script&lang=js&"
export * from "./ConsultarConcursos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff7017e",
  null
  
)

export default component.exports